import { Constraint, Identifiable } from "@planzone/dto";

function match(
  first: Identifiable<Constraint>,
  second: Identifiable<Constraint>,
): boolean {
  return first.uuid === second.uuid;
}

export { match };
